<template>
  <transition name="fade">
    <div v-show="$store.state.show === 'page6'" :class="['page page6', $store.state.show === 'page6' ? 'active' : '']">

      <div class="content">
        <div class="cont">
          <div :class="['screen screen1', $store.state.screen === 'screen14' ? 'active' : '' ? 'active' : '']">
            <!-- <img src="./images/p6-p1-yu1.png" alt="" class="p1-yu1 abs" />
            <img src="./images/p6-p1-yu2.png" alt="" class="p1-yu2 abs" />
            <img src="./images/p6-p1-yu3.png" alt="" class="p1-yu3 abs" />
            <img src="./images/p6-p1-yu4.png" alt="" class="p1-yu4 abs" /> -->

            <img src="./images/p6-p1-diaoxiang.png" alt="" class="p1-diaoxiang abs opacity" />
          </div>

          <div :class="['screen screen2', $store.state.screen === 'screen12' ? 'active' : '' ? 'active' : '']">
            <img src="./images/p6-p1-bg1.png" alt="" class="p1-bg abs opacity" />
            <img src="./images/p6-p2-diaoxiang.png" alt="" class="p2-diaoxiang abs opacity" />
          </div>

          <div :class="['screen screen3', $store.state.screen === 'screen13' ? 'active' : '' ? 'active' : '']">
            <img src="./images/p6-p3-text.png" alt="" class="p3-diaoxiang abs opacity" />
            <img src="./images/p6-p1-text.png" alt="" class="p1-text abs opacity" />
          </div>


          <img src="./images/p6-p1-chuan.png" alt="" class="p1-chuan abs opacity" />
          <img src="./images/p6-p1-molihua.png" alt="" class="p1-molihua abs" />
          <img src="./images/p6-p1-yanzi.png" alt="" class="p1-yanzi abs opacity" />
        </div>
        <img src="./images/yun-zuo.png" alt="" class="yun-zuo abs" />
        <img src="./images/yun-you.png" alt="" class="yun-you abs" />
        <img :class="['tips-up abs']" src="./images/tips-up.png" alt="" />
      </div>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
export default {
  name: "page6",
  components: {},
  data() {
    return {};
  },
  methods: {
    // 下一页
    nextPage() {
      this.$store.dispatch("setPageFn", "page6");
    },
  },
  mounted() {
  },
  watch: {
    "$store.state.show"() {
      // 你需要执行的代码
      if (this.$store.state.show === "page6") {
        // this.pageOperate();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/mixin";

.page6 {
  background: url("./images/p6-p1-bg.jpg") top center no-repeat;
  background-size: 100% auto;


  &.active {
    .p1-chuan  {
      -webkit-animation: identifierxr 0.6s ease-out 0.2s;
      animation: identifierxr 0.6s ease-out 0.2s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }

    
  }

  .screen4 {
    z-index: 13;
  }

  .screen1.active {
    .p1-diaoxiang {
      -webkit-animation: identifieryu 0.6s ease-out 0.2s;
      animation: identifieryu 0.6s ease-out 0.2s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }
  .p2-diaoxiang {
    top: 664px;
    left: 105px;
    width: 355px;
  }

  .p3-diaoxiang {
    top: 630px;
    left: 145px;
    width: 509px;
  }

  .p1-bg {
    z-index: 0 !important;
  }

  .screen2.active {

    .p1-bg {
        top: 0;
        width: 100%;
        -webkit-animation: opacityA 0.2s ease-out 3 alternate 0.3s;
        animation: opacityA 0.2s ease-out 3 alternate 0.3s;
        -webkit-animation-fill-mode: forwards;
        animation-fill-mode: forwards;
      }
  }

  .screen3.active,
  .screen2.active {
    .p3-diaoxiang,
    .p2-diaoxiang {
      -webkit-animation: identifieryu 0.6s ease-out 0.2s;
      animation: identifieryu 0.6s ease-out 0.2s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }



    .p1-text {
      -webkit-animation: identifierx 0.6s ease-out 0.3s;
      animation: identifierx 0.6s ease-out 0.3s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }

  .content {
    .p1-chuan {
      top: 880px;
      left: 266px;
      width: 437px;
    }

    .p1-text {
      top: 47px;
      right: 0;
      width: 721px;
    }

    .p1-diaoxiang {
      top: 630px;
      left: 111px;
      width: 610px;
    }

    .p1-yanzi {
      top: 373px;
      left: 32px;
      width: 670px;
      z-index: 13;
    }

    .p1-yu1 {
      top: 816px;
      left: 0;
      width: 86px;
    }

    .p1-yu2 {
      top: 973px;
      left: 87px;
      width: 157px;
    }

    .p1-yu3 {
      top: 910px;
      left: 390px;
      width: 192px;
    }

    .p1-yu4 {
      top: 825px;
      right: 0;
      width: 124px;
    }

    .p1-molihua {
      width: 100%;
      bottom: 0;
      left: 0;
      z-index: 10;
    }

  }
}
</style>
